<!--
	@name app-home
	@description Home page
	@date 2020/05/20
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name">
		<!-- Carousel -->
		<v-carousel hide-delimiters :show-arrows="$vuetify.breakpoint.mdAndUp" cycle continuous>
			<v-carousel-item class="app--carousel" target="_blank" href="/news/1151927f-b2a2-4bc5-8d5d-08560e7a2aa3">
				<v-container fill-height>
					<v-row no-gutters style="max-width: 700px;">
						<v-col cols="12" sm="12" class="pr-10">
							<div class="text-h3 text-lg-h2 white--text font-weight-bold mb-5">
								Our Member Exclusive Air App is now LIVE!
							</div>
							<div class="text-h4 text-lg-h4 white--text font-weight-light">
								Keeping you connected, informed, and ahead of the curve whilst on the go.
							</div>
							<v-btn to="/news/1151927f-b2a2-4bc5-8d5d-08560e7a2aa3" color="white" outlined class="mt-10" large>
								click here to Find out More
							</v-btn>
						</v-col>
					</v-row>
				</v-container>
			</v-carousel-item>

			<v-carousel-item :src="'generic/Air_Group_Website_Hero_Image.jpg' | urlize" cover>
				<v-container fill-height>
					<div>
						<div class="text-h3 white--text font-weight-bold">
							Comprehensive <br />
							Conversations
						</div>
						<v-btn to="/comprehensive-conversations" color="secondary" class="mt-8">
							Find out More
						</v-btn>
					</div>
				</v-container>
			</v-carousel-item>

			<v-carousel-item :src="'generic/Air-Homepage-Carousel-2.png' | urlize" cover>
				<v-container fill-height>
					<div>
						<div class="text-h3 white--text font-weight-bold">
							Your later life <br />
							lending success?
						</div>
						<div class="text-h6 mt-6 white--text">
							We live and breathe it
						</div>
						<v-btn to="/club-register" color="secondary" class="mt-8">
							Grow with Air
						</v-btn>
					</div>
				</v-container>
			</v-carousel-item>
		</v-carousel>

		<!-- About Us -->
		<div>
			<v-container>
				<div class="text-center d-flex flex-column align-center py-4" :class="{ 'py-12': $vuetify.breakpoint.mdAndUp }">
					<p class="text-h6" style="max-width: 800px">
						Air is the next generation, industry-leading later life lending platform. Enabled by technology, knowledge and people, we offer financial professionals,
						from advisers to lenders, best-in-class digital sourcing tools, personal development services and incentives; all designed to support and reward your
						business growth.
					</p>
					<v-btn to="/advisers" class="mt-6" color="info">
						Start a Sourcing Session
					</v-btn>
				</div>
			</v-container>
		</div>

		<!-- Our Services -->
		<div>
			<v-container>
				<div class="text-h4 text-center mb-4" :class="{ 'mb-10': $vuetify.breakpoint.mdAndUp }">
					<p>Our Services</p>
				</div>
				<v-row>
					<v-col md="4" sm="12" xs="12">
						<v-card class="d-flex flex-column fill-height mx-auto" max-width="350">
							<v-img :src="'generic/man_on_ipad_600x400.jpg' | urlize" height="200px" />

							<v-card-title class="px-6 pt-6">
								<img :src="'logo/brand/lg_airsourcing.svg' | urlize" height="28px" width="auto" />
							</v-card-title>

							<v-card-text class="px-6">
								A sophisticated and innovative technology solution designed to connect you to more opportunities and deliver better customer outcomes.
							</v-card-text>
							<v-spacer />
							<v-card-actions>
								<v-btn to="/sourcing" color="info" small class="ml-4 mb-4">
									Find out more
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
					<v-col md="4" sm="12" xs="12">
						<v-card class="d-flex flex-column fill-height mx-auto" max-width="350">
							<v-img :src="'placeholder/academy-hero.jpg' | urlize" height="200px" />

							<v-card-title class="px-6 pt-6">
								<img :src="'logo/brand/lg_airacademy.svg' | urlize" height="28px" width="auto" />
							</v-card-title>

							<v-card-text class="px-6">
								Innovative learning platform that gives you access to LIBF-accredited training programmes & CPD, which cover a range of critical areas to help grow
								your business and enhance your industry knowledge.
							</v-card-text>
							<v-spacer />
							<v-card-actions>
								<v-btn to="/air-academy" color="info" small class="ml-4 mb-4">
									Find out more
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
					<v-col md="4" sm="12" xs="12">
						<v-card class="d-flex flex-column fill-height mx-auto" max-width="350">
							<v-img :src="'generic/air_club_hero_1800x700-768x299.jpg' | urlize" height="200px" />

							<v-card-title class="px-6 pt-6">
								<img :src="'logo/brand/lg_airclub.svg' | urlize" height="28px" width="auto" />
							</v-card-title>

							<v-card-text class="px-6">
								The UK's largest community of its kind and your accessible gateway to increasing levels of competitive advantage, business growth and profitability.
							</v-card-text>
							<v-spacer />
							<v-card-actions>
								<v-btn to="/air-club" color="info" small class="ml-4 mb-4">
									Find out more
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<!-- Benefits -->
		<div class="mt-2" :class="{ 'mt-10': $vuetify.breakpoint.mdAndUp }">
			<v-container>
				<div class="text-h4 text-center mb-4" :class="{ 'mb-10': $vuetify.breakpoint.mdAndUp }">
					<p>The benefits of the Air platform</p>
				</div>

				<v-row>
					<v-col cols="12" md="3" sm="6" xs="12">
						<div class="text-center px-4">
							<div>
								<svg xmlns="http://www.w3.org/2000/svg" width="74" height="76" viewBox="0 0 74 76" fill="none" style="height: 80px; width: auto">
									<path
										d="M73.6798 59.15C73.6798 50.2 66.3998 42.93 57.4598 42.93C53.5898 42.93 50.0398 44.3 47.2498 46.56L38.5098 41.51V33C41.8498 32.69 44.9098 31.37 47.3498 29.34C47.4198 29.29 47.4798 29.23 47.5298 29.17C51.0098 26.19 53.2298 21.78 53.2298 16.85C53.2298 7.90001 45.9498 0.630005 37.0098 0.630005C28.0698 0.630005 20.7898 7.91001 20.7898 16.85C20.7898 21.78 23.0098 26.19 26.4898 29.17C26.5498 29.23 26.6098 29.29 26.6698 29.34C29.1198 31.37 32.1698 32.69 35.5098 33V41.51L26.7698 46.56C23.9798 44.29 20.4298 42.93 16.5598 42.93C7.60984 42.93 0.339844 50.21 0.339844 59.15C0.339844 64.08 2.55984 68.49 6.02984 71.47C6.08984 71.53 6.14984 71.59 6.21984 71.64C9.02984 73.97 12.6298 75.38 16.5598 75.38C20.4898 75.38 24.0898 73.98 26.8998 71.65C26.9698 71.6 27.0298 71.54 27.0898 71.48C30.5698 68.5 32.7798 64.09 32.7798 59.16C32.7798 55.2 31.3498 51.57 28.9898 48.75L37.0198 44.12L45.0498 48.75C42.6898 51.57 41.2598 55.2 41.2598 59.16C41.2598 64.09 43.4798 68.5 46.9498 71.48C47.0098 71.54 47.0698 71.6 47.1398 71.65C49.9498 73.98 53.5498 75.38 57.4798 75.38C61.4098 75.38 65.0098 73.98 67.8198 71.64C67.8898 71.59 67.9498 71.53 68.0098 71.47C71.4898 68.49 73.6998 64.08 73.6998 59.15H73.6798ZM29.4298 27.69C30.8898 24.9 33.7998 23.09 36.9998 23.09C40.1998 23.09 43.1098 24.91 44.5698 27.69C42.4198 29.19 39.8198 30.09 36.9998 30.09C34.1798 30.09 31.5798 29.2 29.4298 27.69ZM33.7698 16.86C33.7698 15.08 35.2198 13.64 36.9898 13.64C38.7598 13.64 40.2098 15.09 40.2098 16.86C40.2098 18.63 38.7598 20.08 36.9898 20.08C35.2198 20.08 33.7698 18.63 33.7698 16.86ZM23.7698 16.86C23.7698 9.57 29.6998 3.64001 36.9898 3.64001C44.2798 3.64001 50.2098 9.57 50.2098 16.86C50.2098 20.23 48.9298 23.3 46.8498 25.64C45.5998 23.59 43.7498 22 41.5798 21.05C42.5898 19.94 43.2098 18.47 43.2098 16.86C43.2098 13.43 40.4198 10.64 36.9898 10.64C33.5598 10.64 30.7698 13.43 30.7698 16.86C30.7698 18.47 31.3898 19.94 32.3998 21.05C30.2298 22 28.3798 23.59 27.1298 25.64C25.0498 23.3 23.7698 20.23 23.7698 16.86ZM8.96984 69.98C10.4298 67.19 13.3398 65.38 16.5398 65.38C19.7398 65.38 22.6498 67.2 24.1098 69.98C21.9598 71.49 19.3598 72.38 16.5398 72.38C13.7198 72.38 11.1198 71.49 8.96984 69.98ZM13.3098 59.15C13.3098 57.37 14.7598 55.93 16.5298 55.93C18.2998 55.93 19.7498 57.38 19.7498 59.15C19.7498 60.92 18.2998 62.37 16.5298 62.37C14.7598 62.37 13.3098 60.92 13.3098 59.15ZM26.3898 67.93C25.1398 65.88 23.2898 64.29 21.1198 63.34C22.1298 62.23 22.7598 60.76 22.7598 59.15C22.7598 55.72 19.9698 52.93 16.5398 52.93C13.1098 52.93 10.3198 55.72 10.3198 59.15C10.3198 60.76 10.9398 62.23 11.9498 63.34C9.77984 64.29 7.92984 65.88 6.67984 67.93C4.59984 65.59 3.31984 62.52 3.31984 59.15C3.31984 51.86 9.24984 45.93 16.5398 45.93C23.8298 45.93 29.7598 51.86 29.7598 59.15C29.7598 62.52 28.4798 65.59 26.3998 67.93H26.3898ZM44.2198 59.15C44.2198 51.86 50.1498 45.93 57.4398 45.93C64.7298 45.93 70.6599 51.86 70.6599 59.15C70.6599 62.52 69.3799 65.59 67.2999 67.93C66.0499 65.88 64.1998 64.29 62.0298 63.34C63.0398 62.23 63.6598 60.76 63.6598 59.15C63.6598 55.72 60.8698 52.93 57.4398 52.93C54.0098 52.93 51.2198 55.72 51.2198 59.15C51.2198 60.76 51.8398 62.23 52.8598 63.34C50.6898 64.29 48.8398 65.88 47.5898 67.93C45.5098 65.59 44.2298 62.52 44.2298 59.15H44.2198ZM54.2198 59.15C54.2198 57.37 55.6698 55.93 57.4398 55.93C59.2098 55.93 60.6598 57.38 60.6598 59.15C60.6598 60.92 59.2098 62.37 57.4398 62.37C55.6698 62.37 54.2198 60.92 54.2198 59.15ZM49.8798 69.98C51.3398 67.19 54.2498 65.38 57.4498 65.38C60.6498 65.38 63.5598 67.2 65.0198 69.98C62.8698 71.48 60.2698 72.38 57.4498 72.38C54.6298 72.38 52.0298 71.49 49.8798 69.98Z"
										fill="url(#paint0_linear_1848_1997)"
									></path>
									<defs>
										<linearGradient id="paint0_linear_1848_1997" x1="-8.00024" y1="75.38" x2="80.9998" y2="75.3791" gradientUnits="userSpaceOnUse">
											<stop stop-color="#470048"></stop>
											<stop offset="0.272677" stop-color="#670056"></stop>
											<stop offset="0.59989" stop-color="#1B78D8"></stop>
											<stop offset="1" stop-color="#1EB0E1"></stop>
										</linearGradient>
									</defs>
								</svg>
							</div>
							<div class="text-h6 secondary--text mt-2">
								Connected to more
							</div>
							<div class="text-body-2 mt-2">
								Identify the best lender for your clients' needs and receive quick responses to case queries directly from lenders
							</div>
						</div>
					</v-col>
					<v-col cols="12" md="3" sm="6" xs="12">
						<div class="text-center px-4">
							<div>
								<svg xmlns="http://www.w3.org/2000/svg" width="76" height="72" viewBox="0 0 76 72" fill="none" style="height: 80px; width: auto">
									<path
										d="M31.2098 27.62C31.2098 27.62 31.2498 27.69 31.2498 27.73L30.7398 30.7C30.5398 31.88 31.0098 33.05 31.9798 33.76C32.9498 34.47 34.2098 34.56 35.2698 34L37.9398 32.6C37.9398 32.6 38.0198 32.58 38.0598 32.6L40.7298 34C41.1898 34.24 41.6898 34.36 42.1898 34.36C42.8398 34.36 43.4798 34.16 44.0298 33.76C44.9998 33.05 45.4798 31.88 45.2698 30.7L44.7598 27.73C44.7598 27.73 44.7598 27.65 44.7998 27.62L46.9598 25.51C47.8198 24.67 48.1198 23.45 47.7498 22.3C47.3798 21.16 46.4098 20.34 45.2298 20.17L42.2498 19.74C42.2498 19.74 42.1698 19.71 42.1498 19.67L40.8198 16.97C40.2898 15.89 39.2198 15.23 38.0198 15.23C36.8198 15.23 35.7498 15.9 35.2198 16.97L33.8898 19.68C33.8898 19.68 33.8398 19.74 33.7898 19.75L30.7998 20.18C29.6098 20.35 28.6498 21.17 28.2798 22.31C27.9098 23.45 28.2098 24.68 29.0698 25.52L31.2298 27.63L31.2098 27.62ZM31.1098 23.24C31.1298 23.16 31.1798 23.16 31.2098 23.15L34.1998 22.72C35.2198 22.57 36.0998 21.93 36.5498 21.01L37.8798 18.31C37.8798 18.31 37.9098 18.24 37.9898 18.24C38.0698 18.24 38.0898 18.28 38.0998 18.31L39.4398 21.01C39.8998 21.93 40.7798 22.57 41.7898 22.72L44.7698 23.15C44.7698 23.15 44.8498 23.16 44.8698 23.24C44.8898 23.32 44.8698 23.35 44.8398 23.37L42.6798 25.47C41.9398 26.19 41.6098 27.22 41.7798 28.24L42.2898 31.21C42.2898 31.21 42.2998 31.29 42.2398 31.33C42.1798 31.38 42.1298 31.35 42.1098 31.33L39.4398 29.93C38.5298 29.45 37.4398 29.45 36.5298 29.93L33.8598 31.33C33.8598 31.33 33.7898 31.37 33.7298 31.33C33.6698 31.28 33.6698 31.23 33.6798 31.21L34.1898 28.24C34.3598 27.22 34.0298 26.19 33.2898 25.47L31.1298 23.36C31.1298 23.36 31.0698 23.3 31.0998 23.23L31.1098 23.24ZM73.5198 7.42997C71.9498 5.65997 69.7798 4.68997 67.3998 4.68997C65.8198 4.68997 64.4198 5.28997 63.2998 6.00997V5.20997C63.2998 2.83997 61.3698 0.909973 58.9998 0.909973H16.9998C14.6298 0.909973 12.6998 2.83997 12.6998 5.20997V6.00997C11.5798 5.28997 10.1798 4.68997 8.59979 4.68997C6.22979 4.68997 4.04979 5.65997 2.47978 7.42997C0.879785 9.23997 0.0297852 11.69 0.0297852 14.54C0.0297852 19.64 4.04979 23.55 7.59979 27C10.3698 29.69 12.9798 32.24 12.9798 34.6C12.9798 36.36 11.4098 37.58 9.99979 37.58C9.16979 37.58 8.49979 38.25 8.49979 39.08V39.22C8.49979 40.05 9.16979 40.72 9.99979 40.72C12.9598 40.72 16.1198 38.26 16.1198 34.6C16.1198 30.94 13.0398 27.91 9.77979 24.74C6.52979 21.58 3.16979 18.31 3.16979 14.54C3.16979 10.52 5.34979 7.82997 8.59979 7.82997C10.4698 7.82997 12.1698 9.48997 12.7498 10.14C13.3998 28.3 22.4498 41.85 32.0198 45.99V52.82C32.0198 58.17 28.6698 62.52 24.5598 62.52C22.1898 62.52 20.2598 64.45 20.2598 66.82C20.2598 69.19 22.1898 71.12 24.5598 71.12H51.4398C53.8098 71.12 55.7398 69.19 55.7398 66.82C55.7398 64.45 53.8098 62.52 51.4398 62.52C47.3298 62.52 43.9798 58.17 43.9798 52.82V45.99C53.5498 41.85 62.5898 28.3 63.2498 10.14C63.8398 9.49997 65.5398 7.82997 67.3998 7.82997C70.6498 7.82997 72.8298 10.53 72.8298 14.54C72.8298 18.31 69.4698 21.58 66.2198 24.75C62.9598 27.92 59.8798 30.91 59.8798 34.61C59.8798 38.31 63.0398 40.73 65.9998 40.73C66.8298 40.73 67.4998 40.06 67.4998 39.23V39.09C67.4998 38.26 66.8298 37.59 65.9998 37.59C64.5898 37.59 63.0198 36.37 63.0198 34.61C63.0198 32.24 65.6298 29.7 68.4098 27C71.9498 23.55 75.9698 19.64 75.9698 14.54C75.9698 11.69 75.1198 9.23997 73.5198 7.42997ZM51.4398 65.51C52.1598 65.51 52.7398 66.09 52.7398 66.81C52.7398 67.53 52.1598 68.11 51.4398 68.11H24.5598C23.8398 68.11 23.2598 67.53 23.2598 66.81C23.2598 66.09 23.8398 65.51 24.5598 65.51C30.3298 65.51 35.0198 59.81 35.0198 52.81V47.31H40.9798V52.81C40.9798 59.81 45.6698 65.51 51.4398 65.51ZM37.9998 44.31C25.1798 44.31 16.6798 25.35 15.7898 10.91H60.2198C59.1498 31.65 46.7398 44.31 37.9998 44.31ZM60.2998 7.90997H15.6998V5.20997C15.6998 4.48997 16.2798 3.90997 16.9998 3.90997H58.9998C59.7198 3.90997 60.2998 4.48997 60.2998 5.20997V7.90997Z"
										fill="url(#paint0_linear_1848_2012)"
									></path>
									<defs>
										<linearGradient id="paint0_linear_1848_2012" x1="-8.60362" y1="71.12" x2="83.5264" y2="71.119" gradientUnits="userSpaceOnUse">
											<stop stop-color="#470048"></stop>
											<stop offset="0.272677" stop-color="#670056"></stop>
											<stop offset="0.59989" stop-color="#1B78D8"></stop>
											<stop offset="1" stop-color="#1EB0E1"></stop>
										</linearGradient>
									</defs>
								</svg>
							</div>
							<div class="text-h6 secondary--text mt-2">
								Championing progress
							</div>
							<div class="text-body-2 mt-2">
								Exclusive access to products and deals from a variety of lenders and partners. Earn more in commission and rewards as you develop your knowledge and
								submit more cases through Air Club
							</div>
						</div>
					</v-col>
					<v-col cols="12" md="3" sm="6" xs="12">
						<div class="text-center px-4">
							<div>
								<svg xmlns="http://www.w3.org/2000/svg" width="72" height="66" viewBox="0 0 72 66" fill="none" style="height: 80px; width: auto">
									<path
										d="M29.0299 8.10001C28.7499 7.82001 28.3699 7.66001 27.9699 7.66001C27.5699 7.66001 27.1899 7.82001 26.9099 8.10001L23.3499 11.66L22.1299 10.44C21.8499 10.16 21.4699 10 21.0699 10C20.6699 10 20.2899 10.16 20.0099 10.44L19.9099 10.54C19.3299 11.13 19.3299 12.07 19.9099 12.66L22.2899 15.04C22.5699 15.32 22.9499 15.48 23.3499 15.48C23.7499 15.48 24.1299 15.32 24.4099 15.04L29.1299 10.32C29.7099 9.74001 29.7199 8.79001 29.1299 8.20001L29.0299 8.10001ZM60.2099 9.97001H36.4099C35.5799 9.97001 34.9099 10.64 34.9099 11.47V11.61C34.9099 12.44 35.5799 13.11 36.4099 13.11H60.2099C61.0399 13.11 61.7099 12.44 61.7099 11.61V11.47C61.7099 10.64 61.0399 9.97001 60.2099 9.97001ZM28.0099 21.94H21.0099C20.1799 21.94 19.5099 22.61 19.5099 23.44V30.44C19.5099 31.27 20.1799 31.94 21.0099 31.94H28.0099C28.8399 31.94 29.5099 31.27 29.5099 30.44V23.44C29.5099 22.61 28.8399 21.94 28.0099 21.94ZM26.5099 28.94H22.5099V24.94H26.5099V28.94ZM60.2099 25.37H36.4099C35.5799 25.37 34.9099 26.04 34.9099 26.87V27.01C34.9099 27.84 35.5799 28.51 36.4099 28.51H60.2099C61.0399 28.51 61.7099 27.84 61.7099 27.01V26.87C61.7099 26.04 61.0399 25.37 60.2099 25.37ZM28.0099 37.34H21.0099C20.1799 37.34 19.5099 38.01 19.5099 38.84V45.84C19.5099 46.67 20.1799 47.34 21.0099 47.34H28.0099C28.8399 47.34 29.5099 46.67 29.5099 45.84V38.84C29.5099 38.01 28.8399 37.34 28.0099 37.34ZM26.5099 44.34H22.5099V40.34H26.5099V44.34ZM60.2099 40.77H36.4099C35.5799 40.77 34.9099 41.44 34.9099 42.27V42.41C34.9099 43.24 35.5799 43.91 36.4099 43.91H60.2099C61.0399 43.91 61.7099 43.24 61.7099 42.41V42.27C61.7099 41.44 61.0399 40.77 60.2099 40.77ZM63.9899 0.700012H7.9999C4.0799 0.700012 0.899902 3.89001 0.899902 7.80001V47C0.899902 50.92 4.0799 54.1 7.9999 54.1H29.9199C29.3599 58.74 26.2799 62.3 22.5599 62.3C21.7299 62.3 21.0599 62.97 21.0599 63.8C21.0599 64.63 21.7299 65.3 22.5599 65.3H49.4399C50.2699 65.3 50.9399 64.63 50.9399 63.8C50.9399 62.97 50.2699 62.3 49.4399 62.3C45.7199 62.3 42.6399 58.74 42.0799 54.1H63.9999C67.9199 54.1 71.0999 50.91 71.0999 47V7.80001C71.0999 3.89001 67.9199 0.700012 63.9999 0.700012H63.9899ZM42.6899 62.3H29.2999C31.2699 60.27 32.6199 57.38 32.9399 54.1H39.0499C39.3699 57.38 40.7199 60.27 42.6899 62.3ZM68.0899 47C68.0899 49.26 66.2499 51.1 63.9899 51.1H7.9999C5.7399 51.1 3.8999 49.26 3.8999 47V7.80001C3.8999 5.54001 5.7399 3.70001 7.9999 3.70001H63.9999C66.2599 3.70001 68.0999 5.54001 68.0999 7.80001V47H68.0899Z"
										fill="url(#paint0_linear_1848_2007)"
									></path>
									<defs>
										<linearGradient id="paint0_linear_1848_2007" x1="-7.08093" y1="65.3" x2="78.0854" y2="65.2991" gradientUnits="userSpaceOnUse">
											<stop stop-color="#470048"></stop>
											<stop offset="0.272677" stop-color="#670056"></stop>
											<stop offset="0.59989" stop-color="#1B78D8"></stop>
											<stop offset="1" stop-color="#1EB0E1"></stop>
										</linearGradient>
									</defs>
								</svg>
							</div>
							<div class="text-h6 secondary--text mt-2">
								Seriously smarter
							</div>
							<div class="text-body-2 mt-2">
								Our cutting-edge technology allows you to source all later life lending products in real-time and work through the advice process seamlessly
							</div>
						</div>
					</v-col>
					<v-col cols="12" md="3" sm="6" xs="12">
						<div class="text-center px-4">
							<div>
								<svg xmlns="http://www.w3.org/2000/svg" width="83" height="91" viewBox="0 0 83 91" fill="none" style="height: 80px; width: auto">
									<path
										d="M58.287 22.9861C52.9536 18.2116 45.7614 15.9276 38.5935 16.7173C27.064 17.9929 17.7336 27.2869 16.4215 38.8163C15.4496 47.2842 18.7419 55.5941 25.2295 61.0612C27.0519 62.592 28.0967 64.8031 28.0967 67.1114V73.5382C28.0967 74.5466 28.9107 75.3606 29.9191 75.3606H53.0386C54.047 75.3606 54.861 74.5466 54.861 73.5382V67.1236C54.861 64.8152 55.9423 62.5798 57.8254 60.9762C63.4625 56.1773 66.6942 49.1795 66.6942 41.7928C66.6942 34.4062 63.6326 27.7729 58.287 22.9983V22.9861ZM55.4563 58.194C52.7592 60.4902 51.2041 63.7461 51.2041 67.1236V71.7159H31.7293V67.1114C31.7293 63.7218 30.2106 60.4902 27.5743 58.2669C22.0222 53.5896 19.2036 46.4702 20.0419 39.2294C21.1718 29.3765 29.1415 21.4432 38.9944 20.3498C45.2268 19.6573 51.2284 21.5647 55.8572 25.7075C60.4253 29.8018 63.0495 35.6576 63.0495 41.7928C63.0495 47.9281 60.2795 54.0998 55.4563 58.2062V58.194ZM11.1002 39.9583H2.46225C1.45388 39.9583 0.639893 40.7723 0.639893 41.7807C0.639893 42.7891 1.45388 43.6031 2.46225 43.6031H11.1002C12.1086 43.6031 12.9226 42.7891 12.9226 41.7807C12.9226 40.7723 12.1086 39.9583 11.1002 39.9583ZM18.7055 21.6012C19.0578 21.9535 19.5316 22.1357 19.9933 22.1357C20.455 22.1357 20.9288 21.9535 21.2811 21.6012C21.9979 20.8844 21.9979 19.7302 21.2811 19.0256L15.1701 12.9146C14.4533 12.1978 13.2992 12.1978 12.5945 12.9146C11.8899 13.6314 11.8777 14.7856 12.5945 15.4902L18.7055 21.6012V21.6012ZM41.4606 13.2426C42.469 13.2426 43.283 12.4286 43.283 11.4203V2.78232C43.283 1.77395 42.469 0.959961 41.4606 0.959961C40.4523 0.959961 39.6383 1.77395 39.6383 2.78232V11.4203C39.6383 12.4286 40.4523 13.2426 41.4606 13.2426ZM62.928 22.1357C63.3896 22.1357 63.8634 21.9535 64.2158 21.6012L70.3267 15.4902C71.0435 14.7734 71.0435 13.6192 70.3267 12.9146C69.6099 12.21 68.4558 12.1978 67.7511 12.9146L61.6402 19.0256C60.9234 19.7424 60.9234 20.8965 61.6402 21.6012C61.9925 21.9535 62.4663 22.1357 62.928 22.1357ZM80.459 39.9583H71.8211C70.8127 39.9583 69.9987 40.7723 69.9987 41.7807C69.9987 42.7891 70.8127 43.6031 71.8211 43.6031H80.459C81.4674 43.6031 82.2814 42.7891 82.2814 41.7807C82.2814 40.7723 81.4674 39.9583 80.459 39.9583ZM53.0144 78.6773H29.8948C28.8864 78.6773 28.0724 79.4913 28.0724 80.4996C28.0724 81.508 28.8864 82.322 29.8948 82.322H31.1704C32.033 87.2181 36.3094 90.96 41.4606 90.96C46.6118 90.96 50.8883 87.2181 51.7509 82.322H53.0265C54.0349 82.322 54.8489 81.508 54.8489 80.4996C54.8489 79.4913 54.0349 78.6773 53.0265 78.6773H53.0144ZM41.4485 87.3153C38.3262 87.3153 35.6898 85.2013 34.888 82.322H48.009C47.2071 85.2013 44.5708 87.3153 41.4485 87.3153V87.3153Z"
										fill="url(#paint0_linear_1986_4343)"
									></path>
									<defs>
										<linearGradient id="paint0_linear_1986_4343" x1="-8.64169" y1="90.96" x2="90.4053" y2="90.9591" gradientUnits="userSpaceOnUse">
											<stop stop-color="#470048"></stop>
											<stop offset="0.272677" stop-color="#670056"></stop>
											<stop offset="0.59989" stop-color="#1B78D8"></stop>
											<stop offset="1" stop-color="#1EB0E1"></stop>
										</linearGradient>
									</defs>
								</svg>
							</div>
							<div class="text-h6 secondary--text mt-2">
								Empowering know-how
							</div>
							<div class="text-body-2 mt-2">
								LIBF-accredited training, regular market research insights and unrivalled support from industry experts all at your fingertips
							</div>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<!-- Hero -->
		<div class="mt-10">
			<v-img :src="'generic/img_row_background_1920x303_02.jpg' | urlize" height="auto">
				<v-container class="fill-height">
					<div class="text-h4 font-weight-bold white--text text-center py-6">
						In 2023 alone, our members received more than £20.4m in commission, £4.5m above what would have been earned dealing directly with lenders.
					</div>
				</v-container>
			</v-img>
		</div>

		<!-- Testimonials -->
		<div class="py-12" :class="{ 'py-16': $vuetify.breakpoint.mdAndUp }" style="background-color: #f6f6f6">
			<div class="text-center">
				<svg xmlns="http://www.w3.org/2000/svg" width="35" height="28" viewBox="0 0 35 28" fill="none">
					<path
						d="M11.4981 13.36L15.0181 0.639997H7.09813L2.45813 12.16C0.618125 16.56 0.298125 18.08 0.298125 20.16C0.298125 24.72 3.57813 27.84 8.05813 27.84C12.4581 27.84 15.7381 24.8 15.7381 20.16C15.7381 16.88 14.1381 14.48 11.4981 13.36ZM30.3781 13.36L33.8981 0.639997H25.9781L21.3381 12.16C19.4981 16.56 19.1781 18.08 19.1781 20.16C19.1781 24.72 22.4581 27.84 26.9381 27.84C31.3381 27.84 34.6181 24.8 34.6181 20.16C34.6181 16.88 33.0181 14.48 30.3781 13.36Z"
						fill="#670056"
					></path>
				</svg>
			</div>
			<v-container>
				<v-carousel hide-delimiter-background :show-arrows="false" height="auto" light>
					<v-carousel-item v-for="(item, index) in testimonials" :key="index" class="pb-16">
						<div class="text-center mx-auto" style="max-width: 750px">
							<div class="mt-8 text-h6 font-weight-light">
								{{ item.text }}
							</div>
							<div class="font-weight-bold text-h5 mt-6">
								{{ item.author }}
							</div>
							<div class="text-body-1 font-weight-light black--text">
								{{ item.role }}
							</div>
						</div>
					</v-carousel-item>
				</v-carousel>
			</v-container>
		</div>

		<!-- Partners -->
		<div>
			<v-img :src="'generic/img_row_background_1920x303_06.jpg' | urlize" height="auto">
				<v-container class="py-16">
					<div class="text-h4 text-center mb-10 white--text">
						<p>Partners we work with</p>
					</div>
					<div>
						<v-row no-gutters class="ma-n3 pt-3 pb-6 px-6" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
							<v-col cols="12">
								<div id="my-scrollbar" class="d-flex pa-0" style="overflow: auto; width: 100%">
									<v-card v-for="(p, index) in partners" :key="index" elevation="0" class="flex-grow-1 ma-3">
										<img :src="p | urlize" width="150px" height="auto" class="mt-1" />
									</v-card>
								</div>
							</v-col>
						</v-row>
					</div>
				</v-container>
			</v-img>
		</div>

		<!-- Who we are -->
		<div>
			<v-container class="py-8" :class="{ 'py-16': $vuetify.breakpoint.mdAndUp }">
				<v-row>
					<v-col cols="12" md="7">
						<div class="text-h4 mb-6">
							<p>Who we are</p>
						</div>
						<p class="text-body-1">
							Air was founded in 2007 (then known as the Equity Release Club) to help galvanise the best products, commission rates, training and support for advisers
							across the spectrum of the later life lending market.
						</p>
						<p class="text-body-1">
							Led by CEO, Paul Glynn, and his senior management team – who between them have more than 100 years of financial services and later life industry
							experience – our focus has always been on providing advisers with a unified voice in the later life lending market. That includes helping them grow
							their businesses, develop their professional status, improve cash flow and enhance financial outcomes for their clients.
						</p>
						<p class="text-body-1">
							Today, Air's membership represents the single biggest distribution channel in the later life lending market. Around one in every four equity release
							plans are submitted through Air Club, and we have more than 8,000 registered users taking advantage of our award-winning sourcing software – making Air
							the market's leading platform for later life lending professionals.
						</p>
					</v-col>
					<v-col cols="12" md="5">
						<img :src="'generic/IMG_Homepage_Team.jpeg' | urlize" width="100%" class="mt-16 pl-10 hidden-sm-and-down" />
					</v-col>
				</v-row>
			</v-container>
		</div>
	</div>
</template>

<script>
	import Scrollbar from 'smooth-scrollbar';
	import { easeOutExpo } from 'es6-easing';

	export default {
		name: 'app-home',

		components: {},

		data() {
			return {
				interval: null,
				scrollbar: null,
				count: 0,
				testimonials: [
					{
						text: 'With Air Club, we benefit from being part of a collective group and have all the help we need at our fingertips to give the best advice for people in later life.',
						author: 'Paul Saroya',
						role: 'Viva Retirement Solutions'
					},
					{
						text: 'I joined Air Academy a while ago and have always found it very easy to work with and always supportive. The education it provides is first-rate, and the total flexibility allows me to make use of it how and when I want to.',
						author: 'Darren Amos',
						role: 'Specialist Later Life Advisor'
					}
				],
				partners: [
					'logo/brand/white-lg_aviva.png',
					'logo/brand/white-lg_canada-life.png',
					'logo/brand/white-lg_comentis.png',
					'logo/brand/white-lg_dudley.png',
					'logo/brand/white-lg_lv.png',
					'logo/brand/white-lg_hodge.png',
					'logo/brand/white-lg_mansfield.png',
					'logo/brand/white-lg_more2life.png',
					'logo/brand/white-lg_onefamily.png',
					'logo/brand/white-lg_pure_retirement.png',
					'logo/brand/white-lg_the_family_building.png',
					'logo/brand/white-lg_standard.png',
					'logo/brand/white-legal-and-general.png'

				],
                VUE_APP_S3_AIR_ASSETS_URL: process.env.VUE_APP_S3_AIR_ASSETS_URL
			};
		},

		computed: {
			background() {
				if (this.$vuetify.breakpoint.mdAndUp) return 'background--normal';
				return 'background--small';
			}
		},

		mounted() {
			this.initScrollbar();
		},

		methods: {
			initScrollbar() {
				if (!document.querySelector('#my-scrollbar')) return;

				this.scrollbar = Scrollbar.init(document.querySelector('#my-scrollbar'), {
					alwaysShowTracks: true,
					renderByPixels: true
				});

				this.scrollbar.scrollLeft = 750;

				setTimeout(() => {
					this.scrollbar.scrollTo(0, 0, 750, { easing: easeOutExpo });
				}, '500');

				this.interval = setInterval(this.autoScroll, 5000);
			},

			autoScroll() {
				let newPosX = this.count === 0 ? this.count : Math.max(this.count, Math.ceil(this.scrollbar.offset.x / 350)) * 350;
				let duration = newPosX === 0 ? 750 : 500;
				this.scrollbar.scrollTo(newPosX, 0, duration, {
					easing: easeOutExpo
				});
				this.count = newPosX / 350 + 1;
				if (newPosX >= this.scrollbar.limit.x) this.count = 0;
			},

			mouseEnter() {
				clearInterval(this.interval);
			},

			mouseLeave() {
				this.interval = setInterval(this.autoScroll, 5000);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.background--normal {
		background-position: left 30px, left bottom 30px, 50% 50%;
		background-size: auto, auto, contain;
		background-repeat: repeat-x, repeat-x, repeat;
		background-blend-mode: hard-light, hard-light, lighten;
		background-image: url($VUE_APP_S3_AIR_ASSETS_URL+'/cms/AIR+White+Line.jpg'), url($VUE_APP_S3_AIR_ASSETS_URL+'/cms/AIR+White+Line.jpg'), url($VUE_APP_S3_AIR_ASSETS_URL+'/cms/Red-Track-Texture.jpg');
	}
	.background--small {
		background-position: 50% 50%;
		background-size: contain;
		background-repeat: repeat;
		background-blend-mode: lighten;
		background-image: url($VUE_APP_S3_AIR_ASSETS_URL+'/cms/Red-Track-Texture.jpg');
	}

	.app--carousel {
		background-position: 50% 50%;
		background-size: cover;
		background-repeat: repeat;
		background-blend-mode: normal, multiply, normal;
		background-image:
		url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/58dbdfab-d996-416e-b84d-96c36a06324e.png'),
		url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/3ccf48df-98f5-412e-897e-243a0b61ff32.png'),
		url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/11ca8a83-1ae0-4bf3-ab4d-c1e3e5120f85.png');
	}

	#my-scrollbar {
		::v-deep .scroll-content {
			display: flex;
			padding-bottom: 20px;
		}

		::v-deep .scrollbar-thumb {
			background: #fbc02d;
		}
	}

	#overlay {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		background-color: transparent;
		background-image: radial-gradient(ellipse at top left, #1eb0e1, #6464645c, #6464645c);
		z-index: 1;
		opacity: 1;
		mix-blend-mode: multiply;
	}
</style>
